import { HttpRequest, httpErrorHandler } from "../../handler"
export default{
    state:{
        data: [],
        promotionProduct: [],
        homepageCategory: { pageMeta: null, data: [] },
        promotionLocalProduct: { pageMeta: null, data: [] },
        suggestion: []
    },
    mutations:{
        setSettingsHomepageCategory(state,payload){
            state.homepageCategory = payload
        },
        setSettingsPromotionProduct(state,payload){
            state.homepageCategory = payload
        },
        setSettingsPromotionLocalProduct(state,payload){
            state.promotionLocalProduct = payload
        },
        setSettingsSuggestion(state,payload){
            state.suggestion = payload
        }
    },
    actions:{
        async getSettingHomepageCategory(context,payload){
            const url = 'setting/homepageCategory'
            const query = payload
            const {success,result,message} = await HttpRequest.authorizedRequest(url, 'GET', {}, {...query}, {})
            if(success){
                context.commit('setSettingsHomepageCategory', result)
            }else{
                httpErrorHandler(message)
            }
        },
        async createSettingHomepageCategory(context, payload) {
            const url = `setting/homepageCategory`
            const {success,result,message} = await HttpRequest.authorizedRequest(url, 'POST', payload, {})
            if(success){
                return true
            }else{
                httpErrorHandler(message)
            }
        },
        async updateSettingHomepageCategory(context, payload) {
            const { _id } = payload;
            const url = `setting/homepageCategory/${_id}`;
            const {success,result,message} = await HttpRequest.authorizedRequest(url, 'PATCH', payload, {})
            if(success){
                context.commit('setSettingsHomepageCategory', {
                  data: context.state.homepageCategory.data.map(item => {
                    if(item._id == _id) {
                        item = {
                            category: {
                                _id: payload.categoryId,
                                en: payload.categoryName
                            },
                            order: payload.order
                        }
                    }
                    return item;
                  }),
                  pageMeta: context.state.homepageCategory.pageMeta
                });
                return true
            }else{
                httpErrorHandler(message)
            }
        },
        async deleteSettingHomepageCategory(context, payload) {
          const {
            _id
          } = payload
          const url = `setting/homepageCategory/${_id}`
          context.commit('setSettingsHomepageCategory', {
            data: context.state.homepageCategory.data.filter(item => item._id != _id),
            pageMeta: context.state.homepageCategory.pageMeta
          });
          const {
            success,
            result,
            message
          } = await HttpRequest.authorizedRequest(url, "DELETE", {}, {})
          if (success) {
            return true
          } else {
            httpErrorHandler(message)
          }
        },
        async getSettingPromotionProduct(context,payload){
            const url = 'setting/promotionProduct'
            const {query} = payload
            const {success,result,message} = await HttpRequest.authorizedRequest(url, 'GET', {},query, {})
            if(success){
                context.commit('setSettingsPromotionProduct', result)
            }else{
                httpErrorHandler(message)
            }
        },
        async createSettingPromotionProduct(context, payload) {
            const url = `setting/promotionProduct`
            const {success,result,message} = await HttpRequest.authorizedRequest(url, 'POST', payload, {})
            if(success){
                return true
            }else{
                httpErrorHandler(message)
            }
        },
        async updateSettingPromotionProduct(context, payload) {
            const { _id } = payload;
            const url = `setting/promotionProduct/${_id}`;
            const {success,result,message} = await HttpRequest.authorizedRequest(url, 'PATCH', payload, {})
            if(success){
                return true
            }else{
                httpErrorHandler(message)
            }
        },
        async deleteSettingPromotionProduct(context, payload) {
          const {
            _id
          } = payload
          const url = `setting/promotionProduct/${_id}`
          context.commit('setSettingsPromotionProduct', context.state.promotionProduct.filter(item => item._id != _id));
          const {
            success,
            result,
            message
          } = await HttpRequest.authorizedRequest(url, "DELETE", {}, {})
          if (success) {
            return true
          } else {
            httpErrorHandler(message)
          }
        },
        async getSettingPromotionLocalProduct(context,payload){
            const url = 'setting/promotionLocalProduct'
            const query = payload
            const {success,result,message} = await HttpRequest.authorizedRequest(url, 'GET', {}, {...query}, {})
            if(success){
                context.commit('setSettingsPromotionLocalProduct', result)
            }else{
                httpErrorHandler(message)
            }
        },
        async createSettingPromotionLocalProduct(context, payload) {
            const url = `setting/promotionLocalProduct`
            const {success,result,message} = await HttpRequest.authorizedRequest(url, 'POST', payload, {})
            if(success){
                return true
            }else{
                httpErrorHandler(message)
            }
        },
        async updateSettingPromotionLocalProduct(context, payload) {
            const { _id } = payload;
            const url = `setting/promotionLocalProduct/${_id}`;
            const {success,result,message} = await HttpRequest.authorizedRequest(url, 'PATCH', payload, {})
            if(success){
                console.log(payload)
                context.commit('setSettingsPromotionLocalProduct', {
                  data: context.state.promotionLocalProduct.data.map(item => {
                    if(item._id == _id) {
                        item = {
                            ...payload,
                            _id: _id,
                            product: {
                                _id: payload.productId,
                                name: payload.productName
                            },
                        }
                    }
                    return item;
                  }),
                  pageMeta: context.state.promotionLocalProduct.pageMeta
                });
                return true
            }else{
                httpErrorHandler(message)
            }
        },
        async deleteSettingPromotionLocalProduct(context, payload) {
          const {
            _id
          } = payload
          const url = `setting/promotionLocalProduct/${_id}`
          context.commit('setSettingsPromotionLocalProduct', {
            pageMeta: context.state.promotionLocalProduct.pageMeta,
            data: context.state.promotionLocalProduct.data.filter(item => item._id != _id)
          });
          const {
            success,
            result,
            message
          } = await HttpRequest.authorizedRequest(url, "DELETE", {}, {})
          if (success) {
            return true
          } else {
            httpErrorHandler(message)
          }
        },
        async getSettingSuggestion(context,payload){
            const url = 'setting/suggestion'
            const {query} = payload
            const {success,result,message} = await HttpRequest.authorizedRequest(url, 'GET', {},query, {})
            if(success){
                context.commit('setSettingsSuggestion', result)
            }else{
                httpErrorHandler(message)
            }
        },
        async createSettingSuggestion(context, payload) {
            const url = `setting/suggestion`
            const {success,result,message} = await HttpRequest.authorizedRequest(url, 'POST', payload, {})
            if(success){
                return true
            }else{
                httpErrorHandler(message)
            }
        },
        async updateSettingSuggestion(context, payload) {
            const { _id } = payload;
            const url = `setting/suggestion/${_id}`;
            const {success,result,message} = await HttpRequest.authorizedRequest(url, 'PATCH', payload, {})
            if(success){
                return true
            }else{
                httpErrorHandler(message)
            }
        },
        async deleteSettingSuggestion(context, payload) {
          const {
            _id
          } = payload
          const url = `setting/suggestion/${_id}`
          context.commit('setSettingsSuggestion', context.state.suggestion.filter(item => item._id != _id));
          const {
            success,
            result,
            message
          } = await HttpRequest.authorizedRequest(url, "DELETE", {}, {})
          if (success) {
            return true
          } else {
            httpErrorHandler(message)
          }
        },
        async importSettingSuggestion(context, payload) {
            const url = `setting/suggestion/import`
            const {success,result,message} = await HttpRequest.authorizedRequest(url, 'POST', payload, {})
            if(success){
                return true
            }else{
                httpErrorHandler(message)
            }
        },
    }
}